/**
 * PulseOnChange — Wrap any text/value to give it a brief highlight pulse
 * whenever its `value` prop changes. Used on the Dashboard's customer cell
 * so users notice when a background sync (customer rename cascade,
 * denorm-name backfill) has just updated the visible name.
 *
 * Iter 265.2 — sibling to the customer_name denorm sync fix.
 */
import React, { useEffect, useRef, useState } from 'react';

export default function PulseOnChange({
  value,
  children,
  className = '',
  durationMs = 1400,
  colorClass = 'bg-emerald-500/25 ring-1 ring-emerald-400/50',
}) {
  const first = useRef(true);
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    setPulse(true);
    const t = setTimeout(() => setPulse(false), durationMs);
    return () => clearTimeout(t);
  }, [value, durationMs]);

  return (
    <span
      className={`inline-block rounded transition-colors ${pulse ? colorClass : ''} ${className}`}
      style={{ transitionDuration: `${Math.min(durationMs, 600)}ms` }}
      data-pulse={pulse ? 'active' : 'idle'}
    >
      {children}
    </span>
  );
}
